<template>
  <div class="FastPaymentStep2">
    <div class="content-xl">
      <div class="mb-40 text-center text-coolgrey">
        İşleminizi tamamlamak için
        <span class="text-bold text-charcoalgrey">(05XX) XXX 4170</span> numaralı cep telefonunuza gönderilen SMS onay kodunu giriniz.
      </div>
    </div>
    <div class="content-md">
      <SMSConfirm v-model="code" />
      <Checkbox
        v-model="checked"
      >Reklam, promosyon, kampanya duyurularından haberdar olmak için Ticari İletişim Politikası çerçevesinde ticari elektronik ileti almayı onaylıyorum.</Checkbox>
      <button class="mt-40" @click="onClick">Devam Et</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "FastPaymentStep2",
  components: {
    Checkbox: () => import("../../lib/components/Checkbox"),
    SMSConfirm: () => import("../../lib/components/SMSConfirm")
  },
  data: () => ({
    checked: false,
    code: ""
  }),
  methods: {
    onClick() {
      this.$router.push("/select-card");
    }
  }
};
</script>